import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga4";
import "./index.css";
import "./i18n";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import ReactPWAInstallProvider from "@teuteuf/react-pwa-install";

ReactGA.initialize("G-PR8T320NYT", {
  gaOptions: {
    siteSpeedSampleRate: 100,
  },
});
ReactGA.send("pageview");

ReactDOM.render(
  <React.StrictMode>
    <ReactPWAInstallProvider>
      <App />
    </ReactPWAInstallProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
